'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/8/3.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopFirstPage = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: state.background.isLoading
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopFirstPage, _Component);

  function ExperienceShopFirstPage() {
    (0, _classCallCheck3.default)(this, ExperienceShopFirstPage);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopFirstPage).call(this));
  }

  (0, _createClass3.default)(ExperienceShopFirstPage, [{
    key: 'render',
    value: function render() {
      var isLoading = this.props.isLoading;
      // const img = require('./experienceShop.jpg');
      // const experienceShopNearby = require('./experienceShopNearby.png');

      var styles = require('./ExperienceShopFirstPage.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/baozhen/tyd.jpg', className: styles.img }),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/experienceshoplist', className: styles.experienceShopNearby },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/baozhen/button_a.png', alt: '' })
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/', className: styles.backToHome },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/tyd_back.png',
            alt: '' })
        ),
        _react2.default.createElement(_components.LoadModal, { isOpened: isLoading })
      );
    }
  }]);
  return ExperienceShopFirstPage;
}(_react.Component), _class2.propTypes = {
  isLoading: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = ExperienceShopFirstPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopFirstPage/ExperienceShopFirstPage.js
 ** module id = 1468
 ** module chunks = 0
 **/